var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.59 21.51L23.42 25.49M23.41 14.51L16.59 18.49M29 27C29 28.6569 27.6569 30 26 30C24.3431 30 23 28.6569 23 27C23 25.3431 24.3431 24 26 24C27.6569 24 29 25.3431 29 27ZM17 20C17 21.6569 15.6569 23 14 23C12.3431 23 11 21.6569 11 20C11 18.3431 12.3431 17 14 17C15.6569 17 17 18.3431 17 20ZM29 13C29 14.6569 27.6569 16 26 16C24.3431 16 23 14.6569 23 13C23 11.3431 24.3431 10 26 10C27.6569 10 29 11.3431 29 13Z",
    stroke: "currentColor",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphs);
export default __webpack_public_path__ + "static/media/graphs.9780b5f89635e8b970d4d13712d0474f.svg";
export { ForwardRef as ReactComponent };